export const parseIdentifier = ({ identifier, stack }: { identifier: string; stack: { identifier: string }[] }) => {
  let value = identifier;
  value = value.trimStart().trimEnd();
  value = value.replace(/ /g, '-');
  value = value.replace(/[^a-zA-Z0-9_.-]/g, '');
  if (value.startsWith('-') || value.startsWith('_') || value.startsWith('.')) {
    value = value.substring(1);
  }
  if (value.endsWith('-') || value.endsWith('_') || value.endsWith('.')) {
    value = value.slice(0, -1);
  }

  let counter = 1;
  const baseValue = value;
  while (value.length <= 0 || stack.some((component) => component.identifier === value)) {
    value = `${baseValue}${baseValue.length > 0 ? '-' : ''}${counter}`;
    counter++;
  }

  return value;
};
